/**
 * Versión del sistema (frontend) — FUENTE ÚNICA para el badge visible.
 *
 * ⚠️ SUBIR EN CADA CAMBIO: incrementa APP_VERSION en cada PR/merge que altere
 * comportamiento (SemVer: MAJOR.MINOR.PATCH). Debe coincidir con
 * backend/src/version.py (__version__). Ver "Versionado" en README.md.
 */
export const APP_VERSION = '1.9.0';
